export default __webpack_public_path__ + "images/icons/close-4636a32f7d6a267f376091d65635b916.svg";